export default __webpack_public_path__ + "static/media/degen.9b38ca88.png";